export default __webpack_public_path__ + "static/media/down.0f72f796.svg";